/* eslint-disable */
export const LESSON_1 = {
  id: 'chess-lesson-1',
  title: 'The Board — Files, Ranks and Squares',
  subtitle: 'Lesson 1 of 24 · Beginner Module',
  totalMinutes: 60,
  phases: [

    {
      id: 'welcome',
      label: 'Welcome',
      steps: [
        {
          id: 'w1',
          type: 'story',
          boardState: 'empty',
          highlights: [],
          voice: `Welcome, {name}. I am Ms. Momo. And I am about to show you something. Watch the board.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'I am watching!',
        },
        {
          id: 'w2',
          type: 'story',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          voice: `Two armies. Sixteen soldiers each. White on one side. Black on the other. This is not just a game. This is a battle.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Tell me more!',
        },
        {
          id: 'w2b',
          type: 'story',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: ['a1','b1','c1','d1','e1','f1','g1','h1','a2','b2','c2','d2','e2','f2','g2','h2'],
          voice: `Quick question before we go further. Which colour plays from the bottom of the board?`,
          task: 'Which colour plays from the bottom?',
          taskType: 'recap-quiz',
          recapQuestion: 'Which colour starts at the bottom of the board?',
          recapOptions: ['White','Black'],
          recapCorrect: 0,
          recapCorrectVoice: `That is right. White always starts at the bottom. Ranks one and two. Your home. Remember that.`,
          recapWrongVoice: `White starts at the bottom. Ranks one and two. Those are White's home ranks. Always.`,
        },
        {
          id: 'w3',
          type: 'story',
          boardState: 'empty',
          highlights: [],
          voice: `Every piece in chess is a warrior. They all have one mission. Find the enemy King. Trap him. Win the battle. That is chess.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me!',
        },
        {
          id: 'w4',
          type: 'story',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          voice: `This is your battlefield. Sixty four squares. Eight columns. Eight rows. By the end of today you will know every single one of them. Let us begin.`,
          voiceAge: {
            young: `This is your battlefield! Sixty four squares! Eight columns. Eight rows. By the end of today you will know every single one of them. Are you ready? Let us go!`,
            mid: `This is your battlefield. Sixty four squares. Eight columns. Eight rows. By the end of today you will know every single one of them. Let us begin.`,
            teen: `Sixty four squares. Eight columns. Eight rows. Learn them all today. Let us go.`,
          },
          task: null,
          taskType: 'observe',
          continueLabel: 'Let us begin!',
        },
        {
          id: 'w5',
          type: 'story',
          boardState: 'rnbqkb1r/pppp1Qpp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQ1KNR b KQkq - 0 4',
          highlights: ['f7','e8'],
          voice: `Checkmate. The enemy King has nowhere to go. The battle is over. White wins. Four moves. That is what you are going to learn to do.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'I want to learn that!',
        },
        {
          id: 'w6',
          type: 'story',
          boardState: 'empty',
          highlights: [],
          voice: `But before you command an army. You need to know your battlefield. This board has secrets. And I am going to teach you every single one.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Let us start!',
        },
      ],
    },

    {
      id: 'files',
      label: 'Files',
      steps: [
        {
          id: 'f1',
          type: 'instruction',
          boardState: 'empty',
          highlights: [],
          voice: `Look at this board. Sixty four squares. Eight columns going from bottom to top. In chess, we call these columns FILES. Each file has a letter. A to H. Left to right.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Got it. Show me.',
        },
        {
          id: 'f2',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'a',
          highlights: ['a1','a2','a3','a4','a5','a6','a7','a8'],
          voice: `This is File A. The leftmost column. Eight squares tall. Click every square in File A.`,
          task: 'Click every square in file A',
          taskType: 'click-file',
          targetFile: 'a',
          targetSquares: ['a1','a2','a3','a4','a5','a6','a7','a8'],
          successVoice: `File A. You own it.`,
          successVoiceAge: {
            young: `Yes! You found all of File A! Amazing work!`,
            mid: `File A. All eight squares. Well done.`,
            teen: `File A. Done. Move on.`,
          },
        },
        {
          id: 'f3',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'b',
          highlights: ['b1','b2','b3','b4','b5','b6','b7','b8'],
          voice: `File B. Right next to A. Click all eight squares.`,
          task: 'Click every square in file B',
          taskType: 'click-file',
          targetFile: 'b',
          targetSquares: ['b1','b2','b3','b4','b5','b6','b7','b8'],
          successVoice: `File B. Done.`,
          successVoiceAge: {
            young: `Brilliant! File B is all yours!`,
            mid: `File B. Correct.`,
            teen: `File B. Good.`,
          },
        },
        {
          id: 'f3b',
          type: 'observe',
          boardState: 'empty',
          highlights: ['a1','a2','a3','a4','a5','a6','a7','a8','b1','b2','b3','b4','b5','b6','b7','b8'],
          voice: `Two files down. Six to go. Files A and B. Left side of the board. You are building the map piece by piece.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Keep going!',
        },
        {
          id: 'f4',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'c',
          highlights: ['c1','c2','c3','c4','c5','c6','c7','c8'],
          voice: `File C. Third from the left. Click all eight.`,
          task: 'Click every square in file C',
          taskType: 'click-file',
          targetFile: 'c',
          targetSquares: ['c1','c2','c3','c4','c5','c6','c7','c8'],
          successVoice: `Good. You are getting faster.`,
          successVoiceAge: {
            young: `You are getting so fast! Well done!`,
            mid: `File C. You are getting quicker.`,
            teen: `Faster. Good.`,
          },
        },
        {
          id: 'f5',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'd',
          highlights: ['d1','d2','d3','d4','d5','d6','d7','d8'],
          voice: `File D. This one sits right in the heart of the battlefield. Click all eight squares.`,
          task: 'Click every square in file D',
          taskType: 'click-file',
          targetFile: 'd',
          targetSquares: ['d1','d2','d3','d4','d5','d6','d7','d8'],
          successVoice: `File D. Right in the middle. Remember that one.`,
          successVoiceAge: {
            young: `Wonderful! File D is right in the middle of the battle!`,
            mid: `File D. Centre of the battlefield. Remember it.`,
            teen: `File D. Central. Important. Remember it.`,
          },
        },
        {
          id: 'f5b',
          type: 'observe',
          boardState: 'empty',
          highlights: ['c1','c2','c3','c4','c5','c6','c7','c8','d1','d2','d3','d4','d5','d6','d7','d8'],
          voice: `Files C and D. The centre of the board is taking shape. D is especially important. The central files are where the big battles happen.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me more!',
        },
        {
          id: 'f6a',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'e',
          highlights: ['e1','e2','e3','e4','e5','e6','e7','e8'],
          voice: `File E. Even more important than File D. Do you want to know why? The King starts here. Every game. Always. Click all eight squares in File E.`,
          task: 'Click every square in file E',
          taskType: 'click-file',
          targetFile: 'e',
          targetSquares: ['e1','e2','e3','e4','e5','e6','e7','e8'],
          successVoice: `File E. The King's file. You will never forget that.`,
          successVoiceAge: {
            young: `You found the King's file! File E is very special!`,
            mid: `File E. The King lives here. Never forget that.`,
            teen: `File E. King's file. Locked in.`,
          },
        },
        {
          id: 'f6b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/8/4K3 w - - 0 1',
          highlightFile: 'e',
          highlights: ['e1'],
          voice: `See him? The White King. Right there on E1. File E. That is his home. And protecting him is your most important job.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'I will protect him.',
        },
        {
          id: 'f7',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'f',
          highlights: ['f1','f2','f3','f4','f5','f6','f7','f8'],
          voice: `File F. Sixth from the left. Click all eight.`,
          task: 'Click every square in file F',
          taskType: 'click-file',
          targetFile: 'f',
          targetSquares: ['f1','f2','f3','f4','f5','f6','f7','f8'],
          successVoice: `File F. Good.`,
          successVoiceAge: {
            young: `Great job! File F is done!`,
            mid: `File F. Correct.`,
            teen: `File F. Next.`,
          },
        },
        {
          id: 'f8',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'g',
          highlights: ['g1','g2','g3','g4','g5','g6','g7','g8'],
          voice: `File G. Second from the right. Click all eight.`,
          task: 'Click every square in file G',
          taskType: 'click-file',
          targetFile: 'g',
          targetSquares: ['g1','g2','g3','g4','g5','g6','g7','g8'],
          successVoice: `Almost there.`,
          successVoiceAge: {
            young: `Almost finished with all the files! You are doing so well!`,
            mid: `File G. One more to go.`,
            teen: `File G. One left.`,
          },
        },
        {
          id: 'f8b',
          type: 'observe',
          boardState: 'empty',
          highlights: ['f1','f2','f3','f4','f5','f6','f7','f8','g1','g2','g3','g4','g5','g6','g7','g8'],
          voice: `Files F and G. The right side of the board. One more file left. You are almost there.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Last file!',
        },
        {
          id: 'f9',
          type: 'file-intro',
          boardState: 'empty',
          highlightFile: 'h',
          highlights: ['h1','h2','h3','h4','h5','h6','h7','h8'],
          voice: `File H. The last file. All the way on the right. Click every square.`,
          task: 'Click every square in file H',
          taskType: 'click-file',
          targetFile: 'h',
          targetSquares: ['h1','h2','h3','h4','h5','h6','h7','h8'],
          successVoice: `Eight files. A to H. You know them all. That is battlefield knowledge.`,
          successVoiceAge: {
            young: `You did it! All eight files! A to H! You are a superstar!`,
            mid: `Eight files. A to H. All done. That is real progress.`,
            teen: `A to H. All eight. Good. That is the foundation.`,
          },
        },
        {
          id: 'f10',
          type: 'file-quiz',
          boardState: 'empty',
          highlights: [],
          voice: `Now. I am going to test you. I will highlight a file. You tell me its letter. No pressure. But I am watching.`,
          task: 'Which file is highlighted?',
          taskType: 'file-name-quiz',
          quizCount: 6,
          successVoice: `You know your files, {name}. That is impressive.`,
          successVoiceAge: {
            young: `WOW! You know all your files! I am so impressed with you!`,
            mid: `You know your files. That is impressive. Your parents will hear about this.`,
            teen: `Files done. You know them. Good.`,
          },
        },
      ],
    },

    {
      id: 'ranks',
      label: 'Ranks',
      steps: [
        {
          id: 'r1',
          type: 'instruction',
          boardState: 'empty',
          highlights: [],
          voice: `Now the rows. The rows going left to right. In chess we call them RANKS. Eight ranks. Numbered one to eight. Rank one at the bottom. Rank eight at the top.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me the ranks.',
        },
        {
          id: 'r2',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 1,
          highlights: ['a1','b1','c1','d1','e1','f1','g1','h1'],
          voice: `Rank one. The bottom row. White's home base. Click every square.`,
          task: 'Click every square in rank 1',
          taskType: 'click-rank',
          targetRank: 1,
          targetSquares: ['a1','b1','c1','d1','e1','f1','g1','h1'],
          successVoice: `Rank one. White's territory.`,
          successVoiceAge: {
            young: `Yes! Rank one! White's home base! You found them all!`,
            mid: `Rank one. White's home base. Good.`,
            teen: `Rank one. Done.`,
          },
        },
        {
          id: 'r3a',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 2,
          highlights: ['a2','b2','c2','d2','e2','f2','g2','h2'],
          voice: `Rank two. The second row from the bottom. Click all eight squares.`,
          task: 'Click every square in rank 2',
          taskType: 'click-rank',
          targetRank: 2,
          targetSquares: ['a2','b2','c2','d2','e2','f2','g2','h2'],
          successVoice: `Good.`,
          successVoiceAge: {
            young: `Fantastic! Rank two is done!`,
            mid: `Rank two. Correct.`,
            teen: `Rank two. Next.`,
          },
        },
        {
          id: 'r3b',
          type: 'observe',
          boardState: '8/8/8/8/8/8/PPPPPPPP/8 w - - 0 1',
          highlightRank: 2,
          highlights: ['a2','b2','c2','d2','e2','f2','g2','h2'],
          voice: `Eight pawns. All lined up on rank two. These are your foot soldiers. Your front line. Every battle starts with them right here.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'My front line. Got it.',
        },
        {
          id: 'r4',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 3,
          highlights: ['a3','b3','c3','d3','e3','f3','g3','h3'],
          voice: `Rank three. Empty at the start of every game. But not for long. Click all eight.`,
          task: 'Click every square in rank 3',
          taskType: 'click-rank',
          targetRank: 3,
          targetSquares: ['a3','b3','c3','d3','e3','f3','g3','h3'],
          successVoice: `Rank three. Ready for battle.`,
          successVoiceAge: {
            young: `Great! Rank three is ready for the battle!`,
            mid: `Rank three. Ready for battle.`,
            teen: `Rank three. Clear.`,
          },
        },
        {
          id: 'r5',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 4,
          highlights: ['a4','b4','c4','d4','e4','f4','g4','h4'],
          voice: `Rank four. The first rank into enemy territory. Click all eight.`,
          task: 'Click every square in rank 4',
          taskType: 'click-rank',
          targetRank: 4,
          targetSquares: ['a4','b4','c4','d4','e4','f4','g4','h4'],
          successVoice: `You are crossing into the middle of the board now.`,
          successVoiceAge: {
            young: `You are going into enemy territory! How exciting!`,
            mid: `Rank four. Into the middle of the battlefield.`,
            teen: `Rank four. Enemy territory starts here.`,
          },
        },
        {
          id: 'r5b',
          type: 'observe',
          boardState: 'empty',
          highlights: ['a3','b3','c3','d3','e3','f3','g3','h3','a4','b4','c4','d4','e4','f4','g4','h4'],
          voice: `Ranks three and four. You have now crossed into the middle of the board. From here the real battle begins.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Press on!',
        },
        {
          id: 'r6',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 5,
          highlights: ['a5','b5','c5','d5','e5','f5','g5','h5'],
          voice: `Rank five. Deep in enemy territory. Click all eight.`,
          task: 'Click every square in rank 5',
          taskType: 'click-rank',
          targetRank: 5,
          targetSquares: ['a5','b5','c5','d5','e5','f5','g5','h5'],
          successVoice: `Rank five. Getting dangerous up here.`,
          successVoiceAge: {
            young: `Ooooh! Deep in enemy territory! Well done!`,
            mid: `Rank five. Getting dangerous now.`,
            teen: `Rank five. Danger zone.`,
          },
        },
        {
          id: 'r6b',
          type: 'observe',
          boardState: 'empty',
          highlights: ['a4','b4','c4','d4','e4','f4','g4','h4','a5','b5','c5','d5','e5','f5','g5','h5'],
          voice: `Ranks four and five. The middle of the battlefield. Whoever controls these two ranks controls the game. Remember them well.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Keep going!',
        },
        {
          id: 'r7',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 6,
          highlights: ['a6','b6','c6','d6','e6','f6','g6','h6'],
          voice: `Rank six. Very close to the enemy home base. Click all eight.`,
          task: 'Click every square in rank 6',
          taskType: 'click-rank',
          targetRank: 6,
          targetSquares: ['a6','b6','c6','d6','e6','f6','g6','h6'],
          successVoice: `Rank six. One step away from their door.`,
          successVoiceAge: {
            young: `Almost at the enemy base! So close!`,
            mid: `Rank six. One step from the enemy base.`,
            teen: `Rank six. Closing in.`,
          },
        },
        {
          id: 'r8a',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 7,
          highlights: ['a7','b7','c7','d7','e7','f7','g7','h7'],
          voice: `Rank seven. Click all eight squares.`,
          task: 'Click every square in rank 7',
          taskType: 'click-rank',
          targetRank: 7,
          targetSquares: ['a7','b7','c7','d7','e7','f7','g7','h7'],
          successVoice: `Almost at the top.`,
          successVoiceAge: {
            young: `Nearly there! One more rank to go!`,
            mid: `Rank seven. One more.`,
            teen: `Rank seven. Last one coming.`,
          },
        },
        {
          id: 'r8b',
          type: 'observe',
          boardState: 'empty',
          highlightRank: 7,
          highlights: ['a7','b7','c7','d7','e7','f7','g7','h7'],
          voice: `Rank seven. You are one step away from the enemy home base. When your pieces reach this rank, the enemy King is in danger. This is where battles are decided.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'One more rank!',
        },
        {
          id: 'r9a',
          type: 'rank-intro',
          boardState: 'empty',
          highlightRank: 8,
          highlights: ['a8','b8','c8','d8','e8','f8','g8','h8'],
          voice: `Rank eight. The enemy home base. The very top. Click every square.`,
          task: 'Click every square in rank 8',
          taskType: 'click-rank',
          targetRank: 8,
          targetSquares: ['a8','b8','c8','d8','e8','f8','g8','h8'],
          successVoice: `Eight ranks. One to eight. Bottom to top. You know the whole battlefield.`,
          successVoiceAge: {
            young: `YOU DID IT! All eight ranks! You know the whole battlefield! I am so proud of you!`,
            mid: `Eight ranks. One to eight. You know the whole battlefield. Impressive.`,
            teen: `Eight ranks. Done. You have the map.`,
          },
        },
        {
          id: 'r9b',
          type: 'observe',
          boardState: 'empty',
          highlightRank: 8,
          highlights: ['a8','b8','c8','d8','e8','f8','g8','h8'],
          voice: `Rank eight. The enemy home base. This is where their King and army started. When your pieces reach rank eight, you have crossed the entire battlefield. Remember that.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Now let us name squares!',
        },
      ],
    },

    {
      id: 'squares',
      label: 'Square Names',
      steps: [
        {
          id: 's1',
          type: 'instruction',
          boardState: 'empty',
          highlights: [],
          voice: `Now here is where it gets clever. Every square on this board has a secret address. Made of two things. The file letter. And the rank number. File first. Rank second. Always.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me examples!',
        },
        {
          id: 's2',
          type: 'square-guided',
          highlights: ['e4'],
          highlightFile: 'e',
          highlightRank: 4,
          voice: `This square sits in File E. Rank four. So its name is E4. File first. Rank second. E. FOUR. Click on E4.`,
          task: 'Click on e4',
          taskType: 'click-square',
          targetSquares: ['e4'],
          successVoice: `E4. The most famous square in chess. More battles start here than anywhere else.`,
          successVoiceAge: {
            young: `E4! You found the most famous square in all of chess! Amazing!`,
            mid: `E4. The most famous square in chess. Remember it.`,
            teen: `E4. Most contested square in chess. Know it.`,
          },
          wrongVoice: `Find File E. That is the fifth column. Now count up four rows. Where they cross. That is E4.`,
          wrongVoiceAge: {
            young: `Oops! Look for File E. That is the fifth column from the left. Count up four rows. Where they meet is E4. You can do it!`,
            mid: `Not quite. File E is the fifth column. Count up four rows. Where they cross is E4.`,
            teen: `Wrong. File E. Fifth column. Four rows up. Intersection. Try again.`,
          },
        },
        {
          id: 's3',
          type: 'square-guided',
          highlights: ['d5'],
          highlightFile: 'd',
          highlightRank: 5,
          voice: `File D. Rank five. Click on D5.`,
          task: 'Click on d5',
          taskType: 'click-square',
          targetSquares: ['d5'],
          successVoice: `D5. Right next to E4. These two squares together control the entire centre of the battlefield.`,
          successVoiceAge: {
            young: `D5! You found it! D5 and E4 together control the whole middle of the battle!`,
            mid: `D5. Together with E4, these two squares control the centre. Good.`,
            teen: `D5. With E4, these control the centre. Key squares.`,
          },
          wrongVoice: `File D is the fourth column. Rank five is the fifth row up. Find where they meet.`,
          wrongVoiceAge: {
            young: `Nearly! File D is the fourth column from the left. Rank five is five rows up from the bottom. Find where they cross!`,
            mid: `Not quite. File D is column four. Rank five is row five. Find the crossing point.`,
            teen: `Wrong. Column four. Row five. Intersection. Try again.`,
          },
        },
        {
          id: 's4',
          type: 'name-the-square',
          highlights: ['a1'],
          highlightFile: 'a',
          highlightRank: 1,
          voice: `Now I will highlight a square and YOU tell ME its name. Look at this glowing square. What is it called? File first. Rank second. Pick the right answer.`,
          task: 'What is the name of the glowing square?',
          taskType: 'name-the-square',
          options: ['a1','b1','a2','h8'],
          correct: 'a1',
          successVoice: `A1. The bottom left corner. Always dark. Always A1. You will never forget that one.`,
          successVoiceAge: {
            young: `YES! A1! The bottom left corner! It is always dark! You are so clever!`,
            mid: `A1. Bottom left. Always dark. Good. You will not forget that.`,
            teen: `A1. Bottom left. Dark square. Correct.`,
          },
          wrongVoice: `Look at the bottom left corner. That is File A. The bottom row is rank one. So it must be A1.`,
          wrongVoiceAge: {
            young: `Oops! Look at the bottom left corner of the board. That is File A. And the very bottom row is rank one. So the answer is A1. Try again!`,
            mid: `Not quite. Bottom left corner. File A. Rank one. The answer is A1.`,
            teen: `Wrong. Bottom left. File A. Rank one. A1. Try again.`,
          },
        },
        {
          id: 's5',
          type: 'square-guided',
          highlights: ['h8'],
          highlightFile: 'h',
          highlightRank: 8,
          voice: `This corner square is H8. File H. Rank eight. Top right corner. Here is a surprise. H8 is a dark square. Just like the bottom left corner. The two far corners are always the same colour. Click on H8.`,
          task: 'Click on h8',
          taskType: 'click-square',
          targetSquares: ['h8'],
          successVoice: `H8. Dark corner. Just like A1. That is a pattern worth remembering.`,
          successVoiceAge: {
            young: `H8! The top right corner! And it is dark just like A1! You are learning so fast!`,
            mid: `H8. Dark corner. Just like A1. That pattern will help you forever.`,
            teen: `H8. Dark. Same as A1. Diagonal corners match. Remember it.`,
          },
          wrongVoice: `Top right corner. File H is the last column on the right. Rank eight is the very top row. Find where they meet.`,
          wrongVoiceAge: {
            young: `Nearly! Look at the very top right corner of the board. That is where File H meets rank eight. That is H8!`,
            mid: `Not quite. Top right corner. File H. Rank eight. H8.`,
            teen: `Wrong. Top right. File H. Rank eight. H8.`,
          },
        },
        {
          id: 's6',
          type: 'name-the-square',
          highlights: ['c6'],
          highlightFile: 'c',
          highlightRank: 6,
          voice: `Another one. What is the name of this glowing square? Look carefully.`,
          task: 'What is the name of the glowing square?',
          taskType: 'name-the-square',
          options: ['c5','d6','c6','b6'],
          correct: 'c6',
          successVoice: `C6. File C. Rank six. You are reading the board like a chess player.`,
          successVoiceAge: {
            young: `C6! You got it! You are reading the board like a real chess player!`,
            mid: `C6. Correct. You are reading the board well.`,
            teen: `C6. Correct. Good board vision.`,
          },
          wrongVoice: `Count the columns from the left. C is column three. Count the rows from the bottom. Six rows up. Where do they meet? C6.`,
          wrongVoiceAge: {
            young: `Nearly there! Count three columns from the left. That is File C. Then count six rows up from the bottom. Where they cross is C6!`,
            mid: `Not quite. Third column from left is C. Sixth row up is rank six. They meet at C6.`,
            teen: `Wrong. Column three. Row six. C6. Try again.`,
          },
        },
        {
          id: 's7',
          type: 'true-or-false',
          highlights: ['g3'],
          highlightFile: 'g',
          highlightRank: 3,
          voice: `True or false. I say this glowing square is G3. Am I right or am I wrong?`,
          task: 'Is Ms. Momo correct? Is this square g3?',
          taskType: 'true-or-false',
          correct: true,
          successVoice: `Yes. I was right. G3. File G. Rank three. You checked my work. Good soldier.`,
          successVoiceAge: {
            young: `That is right! I was correct! G3! You checked my work and you were right! Great soldier!`,
            mid: `Correct. I was right. G3. File G, rank three. Good checking.`,
            teen: `Correct. G3. Good verification.`,
          },
          wrongVoice: `I was right that time. G is the seventh column. Three rows up from the bottom. That makes it G3. Check carefully next time.`,
          wrongVoiceAge: {
            young: `Oops! I was actually right that time! G is the seventh column and three rows up makes it G3. Keep checking carefully!`,
            mid: `Actually I was right. G is column seven. Three rows up is rank three. G3. Check more carefully.`,
            teen: `Wrong call. I was right. G3. Column seven, row three. Verify before answering.`,
          },
        },
        {
          id: 's8',
          type: 'true-or-false',
          highlights: ['f7'],
          highlightFile: 'f',
          highlightRank: 7,
          voice: `Another true or false. I say this glowing square is B7. Am I right or wrong?`,
          task: 'Is Ms. Momo correct? Is this square b7?',
          taskType: 'true-or-false',
          correct: false,
          successVoice: `You caught me. I was WRONG. That is F7. Not B7. File F. Not B. Well done for catching that.`,
          successVoiceAge: {
            young: `You caught me! I was WRONG! That square is F7 not B7! You are so clever for catching that!`,
            mid: `You caught me. That is F7, not B7. File F, not B. Good eyes.`,
            teen: `Correct catch. That is F7. Not B7. File F is column six, not two. Sharp.`,
          },
          wrongVoice: `I was wrong that time. That square is F7. Not B7. File F is the sixth column. Not B. Always count carefully.`,
          wrongVoiceAge: {
            young: `I was actually wrong that time! That square is F7, not B7! File F is the sixth column, not the second. Count carefully next time!`,
            mid: `I was wrong. That is F7, not B7. File F is column six, not two. Count the columns carefully.`,
            teen: `You missed it. I was wrong. That is F7. File F, sixth column. Not B. Count carefully.`,
          },
        },
        {
          id: 's9',
          type: 'square-guided',
          highlights: ['f2'],
          highlightFile: 'f',
          highlightRank: 2,
          voice: `Last guided one. Find F2. File F. Rank two. This is where the White F pawn starts in a real game. Click on F2.`,
          task: 'Click on f2',
          taskType: 'click-square',
          targetSquares: ['f2'],
          successVoice: `F2. You found it. You have now practised eight squares. You are ready for the real test.`,
          successVoiceAge: {
            young: `F2! You found it! You have practised eight squares now! You are ready for the big test!`,
            mid: `F2. Eight squares practised. You are ready for the independent test.`,
            teen: `F2. Eight squares. Guided phase done. Now the real test.`,
          },
          wrongVoice: `File F is the sixth column from the left. Rank two is the second row from the bottom. Find where they cross.`,
          wrongVoiceAge: {
            young: `Nearly! File F is the sixth column. Rank two is the second row from the bottom. Find where they cross. You can do it!`,
            mid: `Not quite. File F, sixth column. Rank two, second row. Find the crossing point.`,
            teen: `Wrong. Column six. Row two. Intersection. Try again.`,
          },
        },
        {
          id: 's10',
          type: 'square-independent',
          highlights: [],
          voice: `No more help from me. I will call out squares. You find them on your own. No glowing. No hints. Just you and the board. This is the part where you impress me. Ready?`,
          task: 'Find 20 squares independently',
          taskType: 'independent-squares',
          targetSquares: [
            'e1','d8','a4','h5','c3','f6','b2','g7',
            'e5','d4','a8','h1','c7','f3','b6','g2',
            'e3','d6','a5','h4'
          ],
          voiceCorrect: [
            'Yes! e1!','d8 — well done!','a4 — found it!','h5 — correct!',
            'c3 — yes!','f6 — excellent!','b2 — right!','g7 — perfect!',
            'e5 — you are on fire, {name}!','d4 — yes!','a8 — top left corner!',
            'h1 — bottom right!','c7 — near the top!','f3 — yes!',
            'b6 — correct!','g2 — right!','e3 — yes!','d6 — excellent!',
            'a5 — found it!','h4 — PERFECT! Twenty out of twenty attempted!'
          ],
          voiceWrong: `Not quite — remember, {sq}: {file} is column {fileNum} from the left, {rank} is row {rank} from the bottom.`,
          retryThreshold: 15,
          retryVoice: `You found {score} out of twenty. Good effort. Remember — file letter first, rank number second. Find where the column and row cross. Let us try once more.`,
          retryHintVoice: `Here we go again. No hints. Find each square. Go!`,
          successVoice: `{name}, you just found {score} out of twenty squares with no help. On your first lesson. Your parents are going to hear about this.`,
          successVoiceAge: {
            young: `{name}, you found {score} out of twenty squares ALL BY YOURSELF! On your very first lesson! Your mum and dad are going to be SO proud of you! I am proud of you!`,
            mid: `{name}, {score} out of twenty. No help. First lesson. Your parents are going to hear about this. Well done.`,
            teen: `{score} out of twenty. Independent. First lesson. Not bad. Your parents will see that score.`,
          },
        },
      ],
    },

    {
      id: 'speedchallenge',
      label: 'Speed Challenge',
      steps: [
        {
          id: 'sp1',
          type: 'speed-intro',
          boardState: 'empty',
          highlights: [],
          voice: `One more challenge before we meet the pieces. The SPEED CHALLENGE. Fifteen squares. As fast as I can call them. As fast as you can click them. Your score goes to your parents. Make it count. Ready? Three. Two. One.`,
          task: null,
          taskType: 'speed-intro',
          continueLabel: 'START CHALLENGE!',
        },
        {
          id: 'sp2',
          type: 'speed-round',
          boardState: 'empty',
          highlights: [],
          voice: `GO!`,
          task: 'Click each square as fast as you can!',
          taskType: 'speed-round',
          roundNum: 1,
          targetSquares: [
            'e4','a1','h8','d5','c3','f6','b2','g7',
            'e1','h5','a8','d4','f3','b6','g2'
          ],
          timeLimitSecs: 75,
          targetScore: 12,
          successVoice: `Round one done. {score} out of fifteen. Can you beat that in round two?`,
          successVoiceAge: {
            young: `Round one done! You got {score} out of fifteen! Amazing! Can you do even better in round two?`,
            mid: `Round one. {score} out of fifteen. Round two is different squares. Beat that score.`,
            teen: `Round one. {score} out of fifteen. Round two coming. Beat it.`,
          },
          goodVoice: `Not bad. But I think you can do better. Round two now.`,
          tryAgainVoice: `Okay. Round two. Different squares. Fresh start.`,
        },
        {
          id: 'sp3',
          type: 'speed-round',
          boardState: 'empty',
          highlights: [],
          voice: `Round two. Different squares. Faster this time. Three. Two. One. GO!`,
          task: 'Round 2 — beat your first score!',
          taskType: 'speed-round',
          roundNum: 2,
          targetSquares: [
            'g5','b3','f7','c4','h2','a6','e8','d1',
            'g4','b5','f2','c7','h3','a4','e6'
          ],
          timeLimitSecs: 75,
          targetScore: 12,
          successVoice: `OUTSTANDING. {score} out of fifteen in round two. {name}, you have learned the chess board in one lesson. I am genuinely impressed.`,
          successVoiceAge: {
            young: `OUTSTANDING! {score} out of fifteen in round two! {name}, you learned the whole chess board in ONE lesson! I am SO impressed! Your parents are going to be SO proud!`,
            mid: `Outstanding. {score} out of fifteen. You learned the chess board in one lesson. Your parents will hear about this.`,
            teen: `{score} out of fifteen. Round two done. Board learned in one session. Solid.`,
          },
          goodVoice: `You are getting faster. Every time you practise this you will get quicker.`,
          tryAgainVoice: `You are just getting started. The more you practise, the faster you get.`,
        },
      ],
    },

    {
      id: 'wrapup',
      label: 'Wrap Up',
      steps: [
        {
          id: 'wu1',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Before we finish. One quick question. What is the correct name for a square in chess?`,
          task: null,
          taskType: 'recap-quiz',
          continueLabel: 'One more thing before we finish...',
          recapQuestion: 'Which of these correctly names a chess square?',
          recapOptions: ['E4','4E','E-4'],
          recapCorrect: 0,
          recapCorrectVoice: `Yes. File letter first. Rank number second. Always. E4. Never 4E. Never E dash four. Just E4.`,
          recapWrongVoice: `Remember. The file letter always comes first. Then the rank number. So the answer is E4. Not 4E. Not E dash four. E4.`,
        },
        {
          id: 'wu1b',
          type: 'wrapup',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          voice: `You have learned the battlefield today. Files. Ranks. Squares. Every address on this board. Two more quick questions and we are done.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Two more!',
        },
        {
          id: 'wu2',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `One more. How many squares does a chess board have in total?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'How many squares are on a chess board?',
          recapOptions: ['64','32','48','128'],
          recapCorrect: 0,
          recapCorrectVoice: `Sixty four. Eight files. Eight ranks. Eight times eight equals sixty four. You clicked every single one today.`,
          recapWrongVoice: `Sixty four squares. Eight files times eight ranks. Eight times eight equals sixty four. You know this. You clicked them all today.`,
        },
        {
          id: 'wu3',
          type: 'wrapup',
          boardState: 'empty',
          highlights: [],
          voice: `Last one. What do we call the rows that go left and right across the board?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'The left-to-right rows on a chess board are called?',
          recapOptions: ['Ranks','Files','Squares','Lines'],
          recapCorrect: 0,
          recapCorrectVoice: `Ranks. Left to right. Numbered one to eight. Rank one at the bottom. Rank eight at the top. You know your board.`,
          recapWrongVoice: `Ranks. The rows going left and right are ranks. The columns going up and down are files. Ranks go across. Files go up.`,
        },
      ],
    },

    {
      id: 'meetpieces',
      label: 'Meet the Pieces',
      steps: [
        {
          id: 'mp1',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `Now. The battlefield is ready. Time to meet your army. Six types of warrior. Each one moves differently. Each one has a job. Let me introduce them.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Meet my army!',
        },
        {
          id: 'mp2a',
          type: 'observe',
          boardState: '4k3/8/8/8/8/8/8/4K3 w - - 0 1',
          highlights: ['e1','e8'],
          voice: `First. The KING. White King on E1. Black King on E8. The most important piece on the board. Not the most powerful. The most important. If your King is captured, the battle is over. You lose.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'How does he move?',
        },
        {
          id: 'mp2b',
          boardState: '8/8/8/8/8/8/8/4K3 w - - 0 1',
          voice: `Watch how the King moves. I will show you every square he can reach.`,
          task: 'Drag the King to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['d1','d2','e2','f1','f2'],
          narrationSequence: [
            { voice: 'Forward. One square.', squares: ['e2'], squareDelay: 400 },
            { voice: 'Diagonal forward right.', squares: ['f2'], squareDelay: 400 },
            { voice: 'Diagonal forward left.', squares: ['d2'], squareDelay: 400 },
            { voice: 'Right.', squares: ['f1'], squareDelay: 400 },
            { voice: 'Left.', squares: ['d1'], squareDelay: 400 },
            { voice: 'These are every square the King can reach from his starting square. Now drag him to each highlighted square.', squares: [], squareDelay: 0 },
          ],
          successVoice: `Perfect. One square. Any direction. That is the King.`,
          successVoiceAge: {
            young: `Amazing! You found every square the King can reach! One square in any direction!`,
            mid: `Well done. One square, any direction. That is the King.`,
            teen: `Confirmed. One square. Any direction. King movement complete.`,
          },
        },
        {
          id: 'mp2b2',
          boardState: '8/8/8/8/4K3/8/8/8 w - - 0 1',
          voice: `Now from the centre. Watch all eight directions.`,
          task: 'Drag the King to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['d3','d4','d5','e3','e5','f3','f4','f5'],
          narrationSequence: [
            { voice: 'Forward.', pathSquares: [], squares: ['e5'], squareDelay: 400 },
            { voice: 'Backward.', pathSquares: [], squares: ['e3'], squareDelay: 400 },
            { voice: 'Right.', pathSquares: [], squares: ['f4'], squareDelay: 400 },
            { voice: 'Left.', pathSquares: [], squares: ['d4'], squareDelay: 400 },
            { voice: 'All four diagonals.', pathSquares: [], squares: ['f5','d5','f3','d3'], squareDelay: 200 },
            { voice: 'Eight squares. Eight directions. Now drag the King to every highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `Eight directions. One square each. That is the King.`,
          successVoiceAge: {
            young: `Eight squares! Eight directions! You found them all!`,
            mid: `Eight directions. One square each. King confirmed.`,
            teen: `Eight directions. One square. King movement complete.`,
          },
        },
        {
          id: 'mp2c',
          type: 'observe',
          boardState: '8/8/8/8/3K4/8/8/8 w - - 0 1',
          highlights: ['d4'],
          voice: `Your turn. The King is in the centre. Drag him to every square he can reach.`,
          task: 'Drag the King to every square it can reach',
          taskType: 'piece-range',
          targetSquares: ['c3','d3','e3','c4','e4','c5','d5','e5'],
          successVoice: `One square in every direction. That is the King.`,
          successVoiceAge: {
            young: `You found every square the King can reach! One square in every direction! Well done!`,
            mid: `One square in every direction. That is the King. Good.`,
            teen: `One square. Any direction. King movement confirmed.`,
          },
        },
        {
          id: 'mp3a',
          type: 'observe',
          boardState: '3q4/8/8/8/8/8/8/3Q4 w - - 0 1',
          highlights: ['d1','d8'],
          voice: `Next. The QUEEN. The most powerful piece on the board. White Queen on D1. Black Queen on D8. She moves in any direction. As far as she wants. She is your most dangerous weapon.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me her power.',
        },
        {
          id: 'mp3b',
          boardState: '8/8/8/8/8/8/8/3Q4 w - - 0 1',
          voice: `The Queen is the most powerful piece. Watch every direction she can reach.`,
          task: 'Drag the Queen to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a1','a4','b1','b3','c1','c2','d2','d3','d4','d5','d6','d7','d8','e1','e2','f1','f3','g1','g4','h1','h5'],
          narrationSequence: [
            { voice: 'Forward. All the way to the edge.', squares: ['d2','d3','d4','d5','d6','d7','d8'], squareDelay: 150 },
            { voice: 'Right.', squares: ['e1','f1','g1','h1'], squareDelay: 150 },
            { voice: 'Left.', squares: ['c1','b1','a1'], squareDelay: 150 },
            { voice: 'Diagonal forward right.', squares: ['e2','f3','g4','h5'], squareDelay: 150 },
            { voice: 'Diagonal forward left.', squares: ['c2','b3','a4'], squareDelay: 150 },
            { voice: 'Every highlighted square is where the Queen can go. Now drag her to each one.', squares: [], squareDelay: 0 },
          ],
          successVoice: `That is the Queen. The most powerful piece on the board. Use her wisely.`,
          successVoiceAge: {
            young: `Incredible! You found every square the Queen can reach! She is SO powerful!`,
            mid: `That is the Queen's full range. Powerful. Use her wisely.`,
            teen: `Full Queen range confirmed. Maximum coverage. Use her strategically.`,
          },
        },
        {
          id: 'mp3b2',
          boardState: '8/8/8/8/3Q4/8/8/8 w - - 0 1',
          voice: `Now from the centre. Watch the Queen command every direction.`,
          task: 'Drag the Queen to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a1','a4','a7','b2','b4','b6','c3','c4','c5','d1','d2','d3','d5','d6','d7','d8','e3','e4','e5','f2','f4','f6','g1','g4','g7','h4','h8'],
          narrationSequence: [
            { voice: 'Forward.', pathSquares: [], squares: ['d5','d6','d7','d8'], squareDelay: 150 },
            { voice: 'Backward.', pathSquares: [], squares: ['d3','d2','d1'], squareDelay: 150 },
            { voice: 'Right.', pathSquares: [], squares: ['e4','f4','g4','h4'], squareDelay: 150 },
            { voice: 'Left.', pathSquares: [], squares: ['c4','b4','a4'], squareDelay: 150 },
            { voice: 'Diagonal forward right.', pathSquares: [], squares: ['e5','f6','g7','h8'], squareDelay: 150 },
            { voice: 'Diagonal forward left.', pathSquares: [], squares: ['c5','b6','a7'], squareDelay: 150 },
            { voice: 'Diagonal backward right.', pathSquares: [], squares: ['e3','f2','g1'], squareDelay: 150 },
            { voice: 'Diagonal backward left.', pathSquares: [], squares: ['c3','b2','a1'], squareDelay: 150 },
            { voice: 'Twenty seven squares. That is why she is the most powerful piece. Now drag her to every highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `That is the Queen. Twenty seven squares from the centre. Use her wisely.`,
          successVoiceAge: {
            young: `WOW! Twenty seven squares! The Queen is unstoppable!`,
            mid: `Twenty seven squares. Full Queen range. Use her wisely.`,
            teen: `Twenty seven squares. Maximum range. Queen confirmed.`,
          },
        },
        {
          id: 'mp3c',
          type: 'observe',
          boardState: '8/8/8/8/3Q4/8/8/4K3 w - - 0 1',
          highlights: ['d4'],
          voice: `Drag the Queen to every square she can reach from the centre. Show me her power.`,
          task: 'Drag the Queen to every square it can reach',
          taskType: 'piece-range',
          targetSquares: ['a1','b2','c3','e5','f6','g7','h8','a4','b4','c4','e4','f4','g4','h4','d1','d2','d3','d5','d6','d7','d8','a7','b6','c5','e3','f2','g1'],
          successVoice: `That is the Queen. She controls the battlefield. Use her wisely.`,
          successVoiceAge: {
            young: `WOW! Look at all those squares! The Queen is SO powerful! Amazing!`,
            mid: `That is the Queen's reach. Powerful. Use her wisely.`,
            teen: `Queen's range. Maximum coverage. Most powerful piece. Use her strategically.`,
          },
        },
        {
          id: 'mp4a',
          type: 'observe',
          boardState: 'r6r/8/8/8/8/8/8/R6R w - - 0 1',
          highlights: ['a1','h1','a8','h8'],
          voice: `The ROOK. You have two. White Rooks on A1 and H1. Black Rooks on A8 and H8. Rooks move in straight lines. Up. Down. Left. Right. As far as they want. Simple and powerful.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me the Rook.',
        },
        {
          id: 'mp4b',
          boardState: '8/8/8/8/8/8/8/R7 w - - 0 1',
          voice: `The Rook moves in straight lines only. Forward, backward, left and right. Watch.`,
          task: 'Drag the Rook to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a2','a3','a4','a5','a6','a7','a8','b1','c1','d1','e1','f1','g1','h1'],
          narrationSequence: [
            { voice: 'Forward. All the way.', squares: ['a2','a3','a4','a5','a6','a7','a8'], squareDelay: 150 },
            { voice: 'Right. All the way.', squares: ['b1','c1','d1','e1','f1','g1','h1'], squareDelay: 150 },
            { voice: 'Straight lines only. Every highlighted square is where the Rook can go. Drag it to each one.', squares: [], squareDelay: 0 },
          ],
          successVoice: `Straight lines. That is the Rook. Simple and powerful.`,
          successVoiceAge: {
            young: `You found every Rook square! Straight lines only! Great work!`,
            mid: `Straight lines only. The Rook. Simple and powerful.`,
            teen: `Straight lines confirmed. Rook movement complete.`,
          },
        },
        {
          id: 'mp4b2',
          boardState: '8/8/8/8/3R4/8/8/8 w - - 0 1',
          voice: `Now from the centre. Straight lines in all four directions.`,
          task: 'Drag the Rook to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a4','b4','c4','d1','d2','d3','d5','d6','d7','d8','e4','f4','g4','h4'],
          narrationSequence: [
            { voice: 'Forward.', pathSquares: [], squares: ['d5','d6','d7','d8'], squareDelay: 150 },
            { voice: 'Backward.', pathSquares: [], squares: ['d3','d2','d1'], squareDelay: 150 },
            { voice: 'Right.', pathSquares: [], squares: ['e4','f4','g4','h4'], squareDelay: 150 },
            { voice: 'Left.', pathSquares: [], squares: ['c4','b4','a4'], squareDelay: 150 },
            { voice: 'Straight lines only. Fourteen squares. Now drag the Rook to every highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `Straight lines. Fourteen squares. That is the Rook.`,
          successVoiceAge: {
            young: `Fourteen squares! All straight lines! Amazing!`,
            mid: `Fourteen squares. Straight lines only. Rook confirmed.`,
            teen: `Fourteen squares. Straight lines. Rook complete.`,
          },
        },
        {
          id: 'mp4c',
          type: 'observe',
          boardState: '8/8/8/8/3R4/8/8/4K3 w - - 0 1',
          highlights: ['d4'],
          voice: `Drag the Rook to every square it can reach.`,
          task: 'Drag the Rook to every square it can reach',
          taskType: 'piece-range',
          targetSquares: ['a4','b4','c4','e4','f4','g4','h4','d1','d2','d3','d5','d6','d7','d8'],
          successVoice: `Straight lines. That is the Rook. Simple. Powerful.`,
          successVoiceAge: {
            young: `You found all the Rook's squares! Straight lines only! Great work!`,
            mid: `Straight lines only. That is the Rook. Simple and powerful.`,
            teen: `Straight lines. Rook movement confirmed.`,
          },
        },
        {
          id: 'mp5a',
          type: 'observe',
          boardState: '2b2b2/8/8/8/8/8/8/2B2B2 w - - 0 1',
          highlights: ['c1','f1','c8','f8'],
          voice: `The BISHOP. You have two. White Bishops on C1 and F1. Black Bishops on C8 and F8. Bishops move diagonally. Only diagonally. Always. The C1 Bishop stays on dark squares its entire life. The F1 Bishop stays on light squares.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Diagonal only. Got it.',
        },
        {
          id: 'mp5b',
          boardState: '8/8/8/8/8/8/8/2B5 w - - 0 1',
          voice: `The Bishop moves diagonally only. It never changes colour square. Watch both diagonals.`,
          task: 'Drag the Bishop to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a3','b2','d2','e3','f4','g5','h6'],
          narrationSequence: [
            { voice: 'Diagonal forward right. All the way.', squares: ['d2','e3','f4','g5','h6'], squareDelay: 150 },
            { voice: 'Diagonal forward left.', squares: ['b2','a3'], squareDelay: 150 },
            { voice: 'Diagonal only. Always. Drag the Bishop to every highlighted square.', squares: [], squareDelay: 0 },
          ],
          successVoice: `Diagonal only. Always. That is the Bishop.`,
          successVoiceAge: {
            young: `You found every Bishop square! Diagonal only, always!`,
            mid: `Diagonal only. Always. That is the Bishop.`,
            teen: `Diagonals only confirmed. Bishop movement complete.`,
          },
        },
        {
          id: 'mp5b2',
          boardState: '8/8/8/8/3B4/8/8/8 w - - 0 1',
          voice: `Now from the centre. All four diagonals.`,
          task: 'Drag the Bishop to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a1','a7','b2','b6','c3','c5','e3','e5','f2','f6','g1','g7','h8'],
          narrationSequence: [
            { voice: 'Diagonal forward right.', pathSquares: [], squares: ['e5','f6','g7','h8'], squareDelay: 150 },
            { voice: 'Diagonal forward left.', pathSquares: [], squares: ['c5','b6','a7'], squareDelay: 150 },
            { voice: 'Diagonal backward right.', pathSquares: [], squares: ['e3','f2','g1'], squareDelay: 150 },
            { voice: 'Diagonal backward left.', pathSquares: [], squares: ['c3','b2','a1'], squareDelay: 150 },
            { voice: 'Diagonals only. Thirteen squares from the centre. Now drag the Bishop to every highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `Diagonal only. Thirteen squares from the centre. That is the Bishop.`,
          successVoiceAge: {
            young: `Thirteen diagonal squares! The Bishop only goes diagonally!`,
            mid: `Thirteen squares. Diagonals only. Bishop confirmed.`,
            teen: `Thirteen squares. Diagonals only. Bishop complete.`,
          },
        },
        {
          id: 'mp5c',
          type: 'observe',
          boardState: '8/8/8/8/3B4/8/8/4K3 w - - 0 1',
          highlights: ['d4'],
          voice: `Drag the Bishop to every square it can reach.`,
          task: 'Drag the Bishop to every square it can reach',
          taskType: 'piece-range',
          targetSquares: ['a1','b2','c3','e5','f6','g7','h8','g1','f2','e3','c5','b6','a7'],
          successVoice: `Diagonal only. Always. That is the Bishop.`,
          successVoiceAge: {
            young: `You found all the Bishop's diagonal squares! Diagonal only, always! Well done!`,
            mid: `Diagonal only. Always. That is the Bishop. Good.`,
            teen: `Diagonals only. Bishop movement confirmed.`,
          },
        },
        {
          id: 'mp6a',
          type: 'observe',
          boardState: '1n4n1/8/8/8/8/8/8/1N4N1 w - - 0 1',
          highlights: ['b1','g1','b8','g8'],
          voice: `The KNIGHT. The sneakiest piece on the board. White Knights on B1 and G1. Black Knights on B8 and G8. The Knight moves in an L shape. Two squares in one direction. Then one square sideways. And it can jump over other pieces. No other piece can do that.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Show me the L shape.',
        },
        {
          id: 'mp6b',
          boardState: '8/8/8/8/8/8/8/1N6 w - - 0 1',
          voice: `The Knight moves in an L shape. Two squares one way, one square sideways. Watch each move.`,
          task: 'Drag the Knight to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['a3','c3','d2'],
          narrationSequence: [
            { voice: 'Two squares forward, one square right.', pathSquares: ['b2','b3'], squares: ['c3'], squareDelay: 400 },
            { voice: 'Two squares forward, one square left.', pathSquares: ['b2','b3'], squares: ['a3'], squareDelay: 400 },
            { voice: 'Two squares right, one square forward.', pathSquares: ['c1','d1'], squares: ['d2'], squareDelay: 400 },
            { voice: 'Three L shapes from B1. That is every square the Knight can reach. Now drag it to each highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `The L shape. And it jumps over everything. The Knight is full of surprises.`,
          successVoiceAge: {
            young: `You found every Knight square! The sneaky L shape!`,
            mid: `L shape. Jumps over pieces. Knight confirmed.`,
            teen: `L shape. Jumps obstacles. Knight movement complete.`,
          },
        },
        {
          id: 'mp6b2',
          boardState: '8/8/8/8/4N3/8/8/8 w - - 0 1',
          voice: `Now from the centre. Watch all eight L shapes.`,
          task: 'Drag the Knight to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['c3','c5','d2','d6','f2','f6','g3','g5'],
          narrationSequence: [
            { voice: 'Two forward, one right.', pathSquares: ['e5','e6'], squares: ['f6'], squareDelay: 400 },
            { voice: 'Two forward, one left.', pathSquares: ['e5','e6'], squares: ['d6'], squareDelay: 400 },
            { voice: 'Two backward, one right.', pathSquares: ['e3','e2'], squares: ['f2'], squareDelay: 400 },
            { voice: 'Two backward, one left.', pathSquares: ['e3','e2'], squares: ['d2'], squareDelay: 400 },
            { voice: 'Two right, one forward.', pathSquares: ['f4','g4'], squares: ['g5'], squareDelay: 400 },
            { voice: 'Two right, one backward.', pathSquares: ['f4','g4'], squares: ['g3'], squareDelay: 400 },
            { voice: 'Two left, one forward.', pathSquares: ['d4','c4'], squares: ['c5'], squareDelay: 400 },
            { voice: 'Two left, one backward.', pathSquares: ['d4','c4'], squares: ['c3'], squareDelay: 400 },
            { voice: 'Eight L shapes. Eight squares. Now drag the Knight to every highlighted square.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `Eight L shapes. The Knight is the trickiest piece. But you have it.`,
          successVoiceAge: {
            young: `Eight L shapes! You found them all! The Knight is so sneaky!`,
            mid: `Eight L shapes. Eight squares. Knight confirmed.`,
            teen: `Eight L shapes. Knight movement complete.`,
          },
        },
        {
          id: 'mp6c',
          type: 'observe',
          boardState: '8/8/8/8/3N4/8/8/4K3 w - - 0 1',
          highlights: ['d4'],
          voice: `Drag the Knight to every square it can reach.`,
          task: 'Drag the Knight to every square it can reach',
          taskType: 'piece-range',
          targetSquares: ['b3','c2','e2','f3','f5','e6','c6','b5'],
          successVoice: `The L shape. And it jumps over everything. The Knight is full of surprises.`,
          successVoiceAge: {
            young: `You found all the Knight's squares! The sneaky L shape jumper! Brilliant!`,
            mid: `L shape. Jumps over pieces. The Knight is full of surprises.`,
            teen: `L shape. Jumps obstacles. Knight movement confirmed.`,
          },
        },
        {
          id: 'mp7a',
          type: 'observe',
          boardState: '8/pppppppp/8/8/8/8/PPPPPPPP/8 w - - 0 1',
          highlights: [],
          voice: `And finally. The PAWN. You have eight of them. White Pawns on the second rank. Black Pawns on the seventh rank. Pawns move forward. One square at a time. They are small. But do not underestimate them. They are your front line.`,
          task: null,
          taskType: 'observe',
          continueLabel: 'It becomes a Queen!',
        },
        {
          id: 'mp7b',
          boardState: '8/8/8/8/8/8/4P3/8 w - - 0 1',
          voice: `The Pawn moves forward only. One square at a time. On its very first move it can go two squares. Watch.`,
          task: 'Drag the Pawn to every highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['e3','e4'],
          narrationSequence: [
            { voice: 'One square forward.', squares: ['e3'], squareDelay: 400 },
            { voice: 'Two squares forward. But only on its very first move.', squares: ['e4'], squareDelay: 400 },
            { voice: 'Forward only. Drag the Pawn to each highlighted square.', squares: [], squareDelay: 0 },
          ],
          successVoice: `Small but important. Eight pawns. Your front line.`,
          successVoiceAge: {
            young: `You found both Pawn squares! Small but so important!`,
            mid: `Forward only. First move can be two squares. Pawn confirmed.`,
            teen: `Forward one or two on first move. Pawn confirmed.`,
          },
        },
        {
          id: 'mp7b2',
          boardState: '8/8/8/8/4P3/8/8/8 w - - 0 1',
          voice: `Now from the centre. The Pawn has already moved so only one square forward.`,
          task: 'Drag the Pawn to the highlighted square',
          taskType: 'piece-intro-guided',
          targetSquares: ['e5'],
          narrationSequence: [
            { voice: 'One square forward. That is all. The Pawn has already used its two square move.', pathSquares: [], squares: ['e5'], squareDelay: 400 },
            { voice: 'Drag the Pawn forward.', pathSquares: [], squares: [], squareDelay: 0 },
          ],
          successVoice: `One square forward. After the first move, always one square. Remember that.`,
          successVoiceAge: {
            young: `One square forward! The Pawn has already moved so only one square now!`,
            mid: `One square only after first move. Pawn confirmed.`,
            teen: `One square. First move used. Pawn complete.`,
          },
        },
        {
          id: 'mp7c',
          type: 'observe',
          boardState: '4k3/8/8/8/8/8/4P3/4K3 w - - 0 1',
          highlights: ['e2'],
          voice: `Drag the Pawn to every square it can move to from E2.`,
          task: 'Drag the Pawn to every square it can move to',
          taskType: 'piece-range',
          targetSquares: ['e3','e4'],
          successVoice: `Small but important. Eight pawns. Your front line. Your first defence.`,
          successVoiceAge: {
            young: `You found the Pawn's squares! Small but so important! Eight pawns protecting your army!`,
            mid: `Forward only. First move can be two squares. Small but important.`,
            teen: `Forward one or two on first move. Captures diagonal. Pawn confirmed.`,
          },
        },
        {
          id: 'mp8',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `One final test. I will show you a piece. You tell me which one it is. Six pieces. Let us see if you were paying attention.`,
          task: 'Identify each piece',
          taskType: 'piece-spot-quiz',
          quizItems: [
            { fen: '8/8/8/8/3K4/8/8/8 w - - 0 1', piece: 'King', options: ['King','Queen','Rook','Bishop'] },
            { fen: '8/8/8/8/3Q4/8/8/8 w - - 0 1', piece: 'Queen', options: ['Rook','Queen','Knight','Pawn'] },
            { fen: '8/8/8/8/3R4/8/8/8 w - - 0 1', piece: 'Rook', options: ['Bishop','Knight','Rook','Queen'] },
            { fen: '8/8/8/8/3B4/8/8/8 w - - 0 1', piece: 'Bishop', options: ['Rook','Bishop','King','Pawn'] },
            { fen: '8/8/8/8/3N4/8/8/8 w - - 0 1', piece: 'Knight', options: ['Queen','Pawn','Knight','Rook'] },
            { fen: '8/8/8/8/3P4/8/8/8 w - - 0 1', piece: 'Pawn', options: ['Bishop','King','Queen','Pawn'] },
          ],
          successVoice: `You know all six pieces, {name}. King. Queen. Rook. Bishop. Knight. Pawn. Your army is ready.`,
          successVoiceAge: {
            young: `You know all six pieces! King, Queen, Rook, Bishop, Knight, and Pawn! Your army is ready and so are you!`,
            mid: `All six pieces identified. King, Queen, Rook, Bishop, Knight, Pawn. Your army is ready.`,
            teen: `Six for six. All pieces confirmed. Army ready.`,
          },
        },
        {
          id: 'mp9',
          type: 'complete',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          voice: `Lesson one. Done. You know the battlefield. You know your army. You know what you are fighting for. Checkmate. Come back for lesson two. I will teach you how your pieces actually move in battle. The battle is just getting started.`,
          task: null,
          taskType: 'complete',
          continueLabel: 'See you in Lesson 2!',
        },
      ],
    },

  ],
};

export const LESSON_1_BONUS = {
  title: 'Bonus Round — Test Your Chess Brain!',
  phases: [
    {
      id: 'bonus1',
      label: 'Bonus Quiz',
      steps: [
        {
          id: 'b1',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `{name}, you finished the lesson early! That means you get to play the bonus round. Extra questions. Extra points. Are you ready?`,
          task: null,
          taskType: 'observe',
          continueLabel: 'Let us go!',
        },
        {
          id: 'b2',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `Which piece always stays on the same colour square its entire life?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'Which piece never changes square colour?',
          recapOptions: ['The Bishop','The Rook','The Knight','The Pawn'],
          recapCorrect: 0,
          recapCorrectVoice: `The Bishop. It is locked to one colour forever. Light square Bishop. Dark square Bishop. They never cross.`,
          recapWrongVoice: `The answer is the Bishop. It only moves diagonally, so it can never change square colour.`,
        },
        {
          id: 'b3',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `In how many directions can the King move?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'In how many directions can the King move?',
          recapOptions: ['8 directions','4 directions','6 directions','1 direction'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight directions. Forward. Backward. Left. Right. And all four diagonals. The King is slow but he can go anywhere.`,
          recapWrongVoice: `The King moves in eight directions. Forward, backward, left, right, and all four diagonals. Always eight directions.`,
        },
        {
          id: 'b4',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `Which is the most powerful piece on the chess board?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'The most powerful piece in chess is?',
          recapOptions: ['The Queen','The King','The Rook','The Knight'],
          recapCorrect: 0,
          recapCorrectVoice: `The Queen. She moves any direction, any distance. The most powerful warrior on the battlefield.`,
          recapWrongVoice: `It is the Queen. She moves any direction and any distance. No other piece comes close.`,
        },
        {
          id: 'b5',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `In which direction can a Pawn capture an enemy piece?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'A Pawn captures by moving?',
          recapOptions: ['Diagonally forward','Straight forward','Sideways','Diagonally backward'],
          recapCorrect: 0,
          recapCorrectVoice: `Diagonally forward. The Pawn walks straight but strikes diagonally. Sneaky little soldier.`,
          recapWrongVoice: `Pawns capture diagonally forward. They move straight but attack on the diagonal. Remember that.`,
        },
        {
          id: 'b6',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `How many files does a chess board have?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'How many files on a chess board?',
          recapOptions: ['Eight','Six','Ten','Four'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight files. A to H. You clicked every single one today.`,
          recapWrongVoice: `Eight files. A, B, C, D, E, F, G, H. You clicked them all today.`,
        },
        {
          id: 'b7',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `Is the square A1 a light square or a dark square?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'Square A1 is a?',
          recapOptions: ['Dark square','Light square'],
          recapCorrect: 0,
          recapCorrectVoice: `Dark. A1 is always dark. The bottom left corner is always dark. That never changes.`,
          recapWrongVoice: `A1 is dark. The bottom left corner is always a dark square in chess. Always.`,
        },
        {
          id: 'b8',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `How many pawns does each player start with?`,
          task: null,
          taskType: 'recap-quiz',
          recapQuestion: 'Each player starts with how many pawns?',
          recapOptions: ['Eight','Four','Six','Two'],
          recapCorrect: 0,
          recapCorrectVoice: `Eight pawns. One for every file. Your entire front line. All lined up on rank two ready for battle.`,
          recapWrongVoice: `Eight pawns. One on every file. A2 through H2. Your full front line.`,
        },
      ],
    },
    {
      id: 'bonus2',
      label: 'Speed Bonus',
      steps: [
        {
          id: 'bs1',
          type: 'observe',
          boardState: 'empty',
          highlights: [],
          voice: `One more challenge. This time we do the SPEED SQUARE challenge again. But faster. Show me what you have learned.`,
          task: null,
          taskType: 'speed-intro',
          continueLabel: 'I am ready!',
        },
        {
          id: 'bs2',
          type: 'speed-round',
          boardState: 'empty',
          highlights: [],
          voice: `Speed challenge. Find every square I call. Go!`,
          task: 'Find every square called',
          taskType: 'speed-round',
          roundNum: 1,
          targetCount: 15,
          timeLimitSecs: 60,
          targetScore: 12,
          successVoice: `Bonus round complete. Well done.`,
          successVoiceAge: {
            young: `BONUS ROUND COMPLETE! You are a chess board superstar!`,
            mid: `Bonus round complete. You are getting sharper.`,
            teen: `Bonus done. Faster each time. Good.`,
          },
        },
      ],
    },
    {
      id: 'bonus3',
      label: 'Bonus Complete',
      steps: [
        {
          id: 'bend',
          type: 'complete',
          boardState: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
          highlights: [],
          voice: `{name}, you have been absolutely outstanding today. You completed every challenge. Every quiz. And the bonus round. Your parents are going to hear all about this. See you in lesson two.`,
          task: null,
          taskType: 'complete',
          continueLabel: 'See you in Lesson 2!',
        },
      ],
    },
  ],
};
